import { Navigate } from "react-router-dom";
import { useAdminAuth } from "../contexts/AdminAuthContext";

export function AdminProtectedRoute({ children }) {
    const { admin, loading } = useAdminAuth();
    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-ivory" data-testid="admin-loading">
                <div className="font-serif text-xl text-inkDark">Loading...</div>
            </div>
        );
    }
    if (!admin) return <Navigate to="/admin/login" replace />;
    return children;
}
